import { converters as tableConverters } from 'store/table';
import { IAdminCardVoucher } from 'types/income';
import { convertBaseVoucher } from 'store/vouchers';
import { loaders } from './admin-card-vouchers.loaders';
import { AdminCardVoucher } from './admin-card-vouchers.types';

const convertCardVoucher = (voucher: IAdminCardVoucher): AdminCardVoucher => {
  return {
    ...convertBaseVoucher(voucher),
    card: {
      id: voucher.cardId,
      // TODO
      // priceId: voucher.marketplaceItemPriceId,
    },
  };
};

const convertCardVouchers = (
  vouchers: IAdminCardVoucher[],
): AdminCardVoucher[] => {
  return vouchers.map(convertCardVoucher);
};

export const converters = {
  getCardVouchers: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCardVouchers>>) => {
    const { total, page, pageSize, pages } = tableConverters.getTableData(data);

    return {
      items: convertCardVouchers(data.data),
      total,
      page,
      pageSize,
      pages,
    };
  },
  getCardVoucher: ({
    data,
  }: Awaited<ReturnType<typeof loaders.getCardVoucher>>) => {
    return convertCardVoucher(data);
  },
};
